
import { Group } from '../../types';
import { supabase, getCurrentUserId } from '../../supabase';
import { getGroups, setGroups } from './core';
import { handleApiError } from './api-utils';

export const addGroup = async (group: Group): Promise<boolean> => {
  try {
    const userId = await getCurrentUserId();
    if (!userId) {
      handleApiError(
        new Error('No user ID'), 
        'addGroup', 
        'User not authenticated when adding group'
      );
      return false;
    }

    // Ensure proper UUID format for database compatibility
    // Create a new group object with guaranteed UUID format
    const groupForDb = {
      ...group,
      id: group.id.includes('-') ? group.id : crypto.randomUUID()
    };
    
    // Update local storage with the possibly modified ID
    const groups = getGroups();
    setGroups([...groups, groupForDb]);

    console.log('Adding group to Supabase with ID:', groupForDb.id);
    
    const { data, error } = await supabase.from('groups').insert({
      id: groupForDb.id,
      user_id: userId,
      name: groupForDb.name,
      description: groupForDb.description,
    }).select();

    if (error) {
      handleApiError(error, 'addGroup', 'Error adding group to Supabase');
      return false;
    }

    if (groupForDb.productIds.length > 0) {
      const productGroups = groupForDb.productIds.map(productId => ({
        product_id: productId,
        group_id: groupForDb.id
      }));

      const { error: pgError } = await supabase
        .from('product_groups')
        .insert(productGroups);

      if (pgError) {
        handleApiError(pgError, 'addGroup', 'Error adding product-group relationships');
      }
    }

    return true;
  } catch (error: any) {
    handleApiError(error, 'addGroup', 'Error in addGroup');
    return false;
  }
};
